/**
 * BulkMisMetrics Component
 *
 * Displays summary metric cards for bulk operations dashboard
 * Uses Equal DS MetricCard component
 */

import React from 'react';
import { FileStack, Clock, Database } from 'lucide-react';
import { MetricCard } from 'equal-ds-ui';
import type { BulkMisSummary } from '../../../types/bulk-mis';

interface BulkMisMetricsProps {
  summary: BulkMisSummary;
}

export const BulkMisMetrics: React.FC<BulkMisMetricsProps> = ({ summary }) => {
  // TODO: Success rate metrics temporarily disabled - backend does not yet provide
  // completed count and overall_success_rate fields in the summary response.
  // Re-enable when backend API is updated to include these fields.

  // Format average processing time - handle null
  const avgTimeMinutes = summary.avg_processing_time_minutes != null
    ? Number(summary.avg_processing_time_minutes) || 0
    : 0;

  const formattedAvgTime =
    avgTimeMinutes === 0
      ? '0m'
      : avgTimeMinutes > 60
      ? `${(avgTimeMinutes / 60).toFixed(1)}h`
      : `${avgTimeMinutes.toFixed(0)}m`;

  // Format total records - handle string or number
  const totalRecords = Number(summary.total_records_all_batches) || 0;

  return (
    <div className="grid grid-cols-3 gap-6 mb-6">
      <div className="border border-gray-200 rounded-lg">
        <MetricCard
          title="Total Batches"
          value={summary.total_batches.toLocaleString()}
          subtitle="All time"
          icon={<FileStack className="w-6 h-6" />}
          variant="default"
        />
      </div>

      <div className="border border-gray-200 rounded-lg">
        <MetricCard
          title="Avg Processing Time"
          value={formattedAvgTime}
          subtitle="Per batch"
          icon={<Clock className="w-6 h-6" />}
          variant="default"
        />
      </div>

      <div className="border border-gray-200 rounded-lg">
        <MetricCard
          title="Total Records"
          value={totalRecords.toLocaleString()}
          subtitle="Across all batches"
          icon={<Database className="w-6 h-6" />}
          variant="info"
        />
      </div>
    </div>
  );
};
